// @flow
import { client } from 'common/middleware/api';
import { ApiError } from 'common/modules/api';
import { TimezoneActions } from 'common/modules/timezone';
import { Client } from 'common/models/internal/Client';

class ClientActions {
    static FETCH_CLIENT_START = 'FETCH_CLIENT_START';
    static FETCH_CLIENT_COMPLETE = 'FETCH_CLIENT_COMPLETE';
    static INJECT_CLIENT = 'INJECT_CLIENT';
    static FETCH_CLIENT_ERROR = 'FETCH_CLIENT_ERROR';

    static fetchClient({ clientId }: { clientId: string }) {
        const params = {
            clientId
        };

        return dispatch => {
            dispatch(ClientActions.startFetchingClient());
            return new Promise((resolve, reject) => {
                client
                    .fetch(params)
                    .then(response => {
                        const client = Client.fromJS(response);
                        resolve(client);
                        dispatch(TimezoneActions.onClientLoad(client));
                        dispatch(ClientActions.injectClient(client, params));
                    })
                    .catch(error => {
                        reject(error);
                        dispatch(ClientActions.fetchClientError());
                        if (error instanceof ApiError) {
                            return;
                        }
                        throw error;
                    });
            });
        };
    }

    static startFetchingClient(): Object {
        return {
            type: ClientActions.FETCH_CLIENT_START
        };
    }

    static completeFetchingClient(): Object {
        return {
            type: ClientActions.FETCH_CLIENT_COMPLETE
        };
    }

    static fetchClientError(): Object {
        return {
            type: ClientActions.FETCH_CLIENT_ERROR
        };
    }

    static injectClient(client, params): Object {
        return {
            type: ClientActions.INJECT_CLIENT,
            response: client,
            params
        };
    }
}

export default ClientActions;
